import PropTypes from 'prop-types'
import StatusIndicationComponent from '../../../../../atoms/status-indication'
import {
  UserDataContentContainer,
  UserDataName,
  UserDataCompany
} from '../../../styled-components'
import TooltipComponent from '../../../../../atoms/tooltip'
import {
  tooltipAlignOptions,
  tooltipArrowAlignmentOptions,
  tooltipSideOptions
} from '../../../../../atoms/tooltip/constants'
import { iconSizeOptions } from '../../../../../atoms/icons/icons-sizes'
import colorsOptions from '../../../../../fundamentals/colors-styles/constants'
import { useGetAvatarQuery } from '../../../../../../../react-query/avatar/query/use-get-avatar-query'
import { statusIndicationMemberVariantOptions } from '../../../../../atoms/status-indication/constants'
import { useCallback } from 'react'
import { metaDataTaskAssigneeType } from '../../../constants'

const NotificationUserAvatar = ({
  user,
  isFirstItem,
  accessSearchParam = () => ''
}) => {
  const { name, organisationName } = user ?? {}

  const imageUrl =
    user && user.id
      ? `/api/v2/users/${user.id}/avatar${accessSearchParam()}`
      : null

  const { data: cachedAvatarImage, isError: avatarImageHasError } =
    useGetAvatarQuery(imageUrl)

  const renderedAvatarImage =
    cachedAvatarImage || (avatarImageHasError ? imageUrl : null)

  const handleType = useCallback(() => {
    if (user && !user.type) {
      return statusIndicationMemberVariantOptions.MEMBER
    }

    switch (user?.type) {
      case metaDataTaskAssigneeType.TEAM:
        return statusIndicationMemberVariantOptions.TEAM
      case metaDataTaskAssigneeType.CONTACT:
        return statusIndicationMemberVariantOptions.CONTACT
      default:
        return statusIndicationMemberVariantOptions.MEMBER
    }
  }, [user])

  return (
    <TooltipComponent.Provider>
      <TooltipComponent.Root>
        <TooltipComponent.Trigger>
          <StatusIndicationComponent
            image={renderedAvatarImage}
            size={iconSizeOptions['ICON-L']}
            variant={handleType()}
          />
        </TooltipComponent.Trigger>
        <TooltipComponent.Content
          side={
            isFirstItem ? tooltipSideOptions.BOTTOM : tooltipSideOptions.TOP
          }
          align={tooltipAlignOptions.END}
          sideOffset={5}
        >
          <UserDataContentContainer>
            <StatusIndicationComponent
              variant={handleType()}
              image={renderedAvatarImage}
              size={iconSizeOptions['ICON-L']}
              iconColor={colorsOptions.greys.white}
            />
            <UserDataName>{name}</UserDataName>
            <UserDataCompany>{organisationName}</UserDataCompany>
          </UserDataContentContainer>
          <TooltipComponent.Arrow
            arrowAlignment={tooltipArrowAlignmentOptions.START}
          />
        </TooltipComponent.Content>
      </TooltipComponent.Root>
    </TooltipComponent.Provider>
  )
}

NotificationUserAvatar.propTypes = {
  user: PropTypes.object,
  isFirstItem: PropTypes.bool,
  accessSearchParam: PropTypes.func
}

export default NotificationUserAvatar
